export default __webpack_public_path__ + "static/media/kitchen5-beforeE-480w.7afac5a6.webp";